export default "__VITE_ASSET__BPtqi7YA__"